import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfig } from '@nha/api/shared/classes/api-config.class';

@Injectable({
	providedIn: 'any'
})
export class AttendanceApiConfiguration extends ApiConfig {
	constructor() {
		const httpClient = inject(HttpClient);

		super(httpClient, 'attendance');
	}
}
